import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./Hero.module.css";

// Substitua o caminho abaixo pelo arquivo real em /src/assets/
// Ex: import heroImage from "../../assets/hero-big.jpg";
import heroImage from "../../assets/hero.png"; // <-- ajuste aqui

export default function Hero() {
  const { t } = useTranslation("home");

  return (
    <header
      className={styles.heroWrap}
      role="banner"
      aria-label={t ? t("hero_aria_label") : "Hero"}
    >
      <div
        className={styles.heroBg}
        style={{ backgroundImage: `url(${heroImage})` }}
      />

      <div className={styles.overlay} />

      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>
            {t ? t("title") : "Entenda sua personalidade com ciência e prática"}
          </h1>

          <p className={styles.lead}>
            {t
              ? t("subtitle_pre")
              : "Um modelo único que separa Temperamento (tendências) e Caráter (habilidades treináveis)."}
          </p>

          <ul className={styles.benefits}>
            {/* <li>
              {t
                ? t("bullet.temperament")
                : "Temperamento: suas tendências naturais"}
            </li>
            <li>
              {t
                ? t("bullet.character")
                : "Caráter: processos que podem ser treinados"}
            </li> */}
            <li className={styles.pill1}>
              {t ? t("bullet.science1") : "Psicologia do comportamento"}
            </li>
            <li className={styles.pill1}>
              {t ? t("bullet.science2") : "Psiquiatria"}
            </li>
            <li>
              {t ? t("bullet.act") : "Terapia de Aceitação e Compromisso"}
            </li>
            <li>{t ? t("bullet.pbt") : "Terapia Baseada em Processos"}</li>
          </ul>

          <div className={styles.ctas}>
            <a
              className={styles.primary}
              href="/registration"
              aria-label="Fazer o teste"
            >
              {t ? t("cta_start") : "Participar — é gratuito"}
            </a>
            {/* <a
              className={styles.secondary}
              href="/pricing"
              aria-label="Ver planos"
            >
              {t ? t("cta_plans") : "Ver planos"}
            </a> */}
          </div>
        </div>

        {/* <aside className={styles.previewCard} aria-hidden>
          <div className={styles.previewInner}>
            <strong>{t ? t("hero_sample_label") : "Relatório — prévia"}</strong>
            <p className={styles.previewText}>
              {t
                ? t("hero_sample_sub")
                : "Resumo prático: forças, desafios e um mini-plano para 2 semanas."}
            </p>

            <div className={styles.previewList}>
              <div className={styles.previewItem}>
                <strong>Temperamento</strong> — Tendências
              </div>
              <div className={styles.previewItem}>
                <strong>Caráter</strong> — Habilidades
              </div>
            </div>

            <a className={styles.previewCTA} href="/personality-quiz">
              {t ? t("cta_start") : "Começar teste"}
            </a>
          </div>
        </aside> */}
      </div>

      <a
        href="#start"
        className={styles.scrollDown}
        aria-label="Ir para conteúdo"
      >
        <span className={styles.mouse} />
        <span className={styles.sdowntxt}>
          {t ? t("scroll_down") : "Saiba mais"}
        </span>
      </a>
    </header>
  );
}
